import SegmentedTabs from '@/components/SegmentedTabs'
import { SegmentedTab } from '@/components/SegmentedTabs/SegmentedTab.jsx'
import { THREAD_WORKSPACE_SCOPE_TABS } from './threadWorkspaceScope'

export default function ThreadsSearchDialogWorkspaceTabs({ value, onChange }) {
  return (
    <SegmentedTabs
      appearance="pulse32"
      value={value}
      onChange={(_event, next) => onChange(next)}
      aria-label="Workspace scope"
    >
      {THREAD_WORKSPACE_SCOPE_TABS.map((tab) => (
        <SegmentedTab key={tab.value} appearance="pulse32" value={tab.value} label={tab.label} />
      ))}
    </SegmentedTabs>
  )
}
